/*
 *  Cart Template Scripts
 *    Scripts that are only meant to run on the Cart Template.
 *
 *  Version:
 *    1.0.0 - 2020/08/12
 */

import $ from 'jquery';
import { CartQuantitySelector } from './../objects/quantity/CartQuantitySelector';
import { Accordion } from './../objects/accordion/Accordion';

export const CART_TEMPLATE_SELECTOR = '[data-cart-template]';
export const CART_PRODUCT_SELECTOR = 'data-cart-template-product';
export const CART_ACCORDION = '[data-cart-accordion]';
// export const CART_TEMPLATE_BODY = '[data-cart-body]';
// export const CART_TEMPLATE_BODY_LOADER = '[data-cart-body-loader]';

export const CLASS_VISIBLE = 'is-visible';

class CartTemplate {
  constructor(container) {
    this.container = container;
    this.quantitySelectors = [];

    // Setup quantity selectors
    this.setupQuantitySelectors();

    // Setup product accordion
    this.cartAccordion = new Accordion(this.container.find(CART_ACCORDION));
  }

  setupQuantitySelectors() {
    //Destroy
    this.quantitySelectors.forEach(e => e.destroy());

    //Now recreate
    this.quantitySelectors = [];

    $(`[${CART_PRODUCT_SELECTOR}]`).each((i, e) => {
      let self = $(e);
      let index = self.attr('data-index');
      this.quantitySelectors.push(new CartQuantitySelector(index, self));
    });
  }
}

// Initialize
$(document).ready($(CART_TEMPLATE_SELECTOR).each((i,e) => new CartTemplate($(e))));